import AccountAPI from "../API/account";

export function parseOrganizationType(value) {
  if (value == null || value === "") return null;
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
}

export function getMemberOrganizationType(member) {
  return parseOrganizationType(
    member?.organization_type ?? sessionStorage.getItem("organization_type")
  );
}

export function isPatentOfficeStaff(auth) {
  const rank = auth ?? sessionStorage.getItem("auth");
  return Boolean(window.$Global?.checkAuth?.("대리인", Number(rank)));
}

function cacheManagedOrganizationType(companyIdx, organizationType) {
  if (!companyIdx || organizationType == null) return;
  sessionStorage.setItem(
    "manage_company_organization_type",
    String(organizationType)
  );
  sessionStorage.setItem(
    "manage_company_organization_type_for",
    String(companyIdx)
  );
  sessionStorage.setItem("organization_type", String(organizationType));
}

/**
 * UI용 organization_type.
 * - 일반: 로그인 멤버 organization_type
 * - 특사(대리인): manage_company_idx에 해당하는 연결 기업의 organization_type
 */
export async function resolveWorkingOrganizationType(options = {}) {
  const { auth, member } = options;
  const memberOrg = getMemberOrganizationType(member);
  const rank = auth ?? member?.auth ?? member?.rank;

  if (!isPatentOfficeStaff(rank)) return memberOrg;

  const selectedIdx = String(
    member?.manage_company_idx ||
      sessionStorage.getItem("manage_company_idx") ||
      ""
  ).trim();
  if (!selectedIdx) return memberOrg;

  const cachedFor = sessionStorage.getItem(
    "manage_company_organization_type_for"
  );
  const cached = sessionStorage.getItem("manage_company_organization_type");
  if (cachedFor === selectedIdx && cached != null && cached !== "") {
    return parseOrganizationType(cached);
  }

  try {
    const res = await AccountAPI.getCompanyToAgentList();
    const list = Array.isArray(res?.data) ? res.data : [];
    const match = list.find((row) => {
      const idx = String(row.idx ?? row.company_idx ?? "").trim();
      return idx === selectedIdx;
    });
    const fromConnected = parseOrganizationType(match?.organization_type);
    if (fromConnected != null) {
      cacheManagedOrganizationType(selectedIdx, fromConnected);
      return fromConnected;
    }
  } catch (_) {
    /* fall through */
  }

  return memberOrg;
}

export function applyManagedOrganizationType(companyIdx, organizationType) {
  const parsed = parseOrganizationType(organizationType);
  if (parsed == null) return;
  cacheManagedOrganizationType(companyIdx, parsed);
}
